module.exports = __webpack_public_path__ + "static/media/category-dots.36e7d26f.svg";